import { render, staticRenderFns } from "./periodosInstitucion.vue?vue&type=template&id=2839e290"
import script from "./periodosInstitucion.vue?vue&type=script&lang=js"
export * from "./periodosInstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports